import { httpClient } from '@/modules/common/services/http/http-client';
import {
  IGetSuggestedPortfoliosResponse,
  ICreateSuggestedPortfolioResponse,
  IGetSuggestedPortfolioDetailsResponse
} from './types';

const formattedDate = (date: string) => {
  return date.split('/').reverse().join('-');
};

export const http = httpClient.withOptions({
  baseURL: process.env.VUE_APP_BFF_INVESTMENTS_URL
});

export function getSuggestedPortfolios(
  initialInvestment: number,
  goalDate: string
): Promise<IGetSuggestedPortfoliosResponse> {
  return http.get(
    `v2/home/portfolios/suggested?initialInvestment=${initialInvestment}&goalDate=${formattedDate(
      goalDate
    )}`
  );
}

export function getSuggestedPortfolioDetails(
  managedPortfolioId: string,
  goalDate: string,
  initialInvestment: number
): Promise<IGetSuggestedPortfolioDetailsResponse> {
  const params = {
    goalDate: formattedDate(goalDate),
    initialInvestment
  };
  return http.get(`v2/home/portfolios/suggested/${managedPortfolioId}`, {
    params
  });
}

export function createSuggestedPortfolio(
  portfolioName: string,
  goalDate: string,
  initialInvestment: number,
  managedPortfolioId: string
): Promise<ICreateSuggestedPortfolioResponse> {
  const params = {
    portfolioName,
    goalDate: formattedDate(goalDate),
    initialInvestment,
    managedPortfolioId
  };
  return http.post(`v2/home/portfolios/suggested`, params);
}
